import * as React from "react";
const SvgCreditCard = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M1.871 3.754V20.256H22.13V3.754H12ZM3.38 5.252H20.62v2.246H3.38V6.375Zm0 3.752H20.62v2.248H3.38v-1.125zm0 3.744H20.62v6H3.38v-3zm11.433 2.246v1.508h3.754l-.002-.75-.002-.752-1.875-.002z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgCreditCard;
